import { useEffect, useRef, EffectCallback, DependencyList } from 'react'

export default function useEffectSkipFirst(
  effect: EffectCallback,
  deps?: DependencyList,
  skip: () => boolean = (): boolean => false,
) {
  const firstUpdate = useRef(true)
  useEffect((): void => {
    if (skip()) {
      return
    }
    if (firstUpdate.current) {
      firstUpdate.current = false
      return
    }

    effect()
  }, deps)
}
